import { toast } from 'react-toastify'
import i18n from '../i18n/i18n'

export const makeWarningToast = detail => {
  toast.warning(detail, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  })
}

export const makeErrorToast = err => {
  toast.error(err, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  })
}
export const makeSuccessToast = err => {
  toast.success(err, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  })
}
export const msg = i18n.t('errors:unxpected')
